module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/event_finished-42d20ec5657cd5fe74193b290847230d.png";